/**
 * Utility functions for data hashing
 */

/**
 * Hash email using SHA-256 for privacy-compliant tracking
 * @param {string} email - Email address to hash
 * @returns {Promise<string>} - Hashed email string
 */
export async function hashEmail(data) {
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data.trim().toLowerCase()); // Normalize the data
    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}

/**
 * Hash any data using SHA-256
 * @param {string} data - Data to hash
 * @returns {Promise<string>} - Hashed data string
 */
export async function hashData(data) {
    if (!data || typeof data !== 'string') {
        throw new Error('Valid data is required for hashing');
    }

    try {
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(data);
        const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        
        return hashHex;
    } catch (error) {
        console.error('Error hashing data:', error);
        throw new Error('Failed to hash data');
    }
}
